import { UseCase } from '@/core/base/use-case';
import { LoginGuestResponse } from '../models/loginGuest-response.model';
import { UserRepository } from '../repositories/user.respository';
import { Observable } from 'rxjs';
import { LoginUserRequest } from '../models/loginUser-request.model';

export class LoginUserUseCase
    implements UseCase<LoginUserRequest, LoginGuestResponse>
{
    constructor(private readonly repository: UserRepository) {}

    execute(request: LoginUserRequest): Observable<LoginGuestResponse> {
        return this.repository.loginUser(request);
    }
}
